/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Backup frequency. `UNSPECIFIED` is supported only in responses. 
*/
export enum HighFrequencyBackupScheduleFrequency {
  HIGH_FREQUENCY_BACKUP_SCHEDULE_INTERVAL = 'INTERVAL',
  HIGH_FREQUENCY_BACKUP_SCHEDULE_DAILY = 'DAILY',
  HIGH_FREQUENCY_BACKUP_SCHEDULE_WEEKLY = 'WEEKLY',
  HIGH_FREQUENCY_BACKUP_SCHEDULE_MONTHLY = 'MONTHLY',
  HIGH_FREQUENCY_BACKUP_SCHEDULE_ANNUALLY = 'ANNUALLY',
  HIGH_FREQUENCY_BACKUP_SCHEDULE_UNSPECIFIED = 'UNSPECIFIED'
}
